import { ClaimSeasonThreeResponse } from "../../types";

export const claimSeasonThreeModel = (response: ClaimSeasonThreeResponse): ClaimSeasonThreeResponse => response;
